import tw, { styled } from "twin.macro";

export const DocumentTableWrapper = styled.div(() => [
  tw`bg-white rounded-lg p-8 flex flex-col flex-1 min-h-0`,
]);
